import { createSlice } from "@reduxjs/toolkit";
import { getChefMenuAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getChefMenuSlice = createSlice({
  name: "getChefMenu",
  initialState: data,
  reducers: {
   getChefMenuSlice(state) {
      state.isLoading = true;
    },
   getChefMenuSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefMenuSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getChefMenuSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefMenuHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getChefMenuAction.getChefMenuSlice());
    const response: any = await getChefMenuAPI(id);
    
    dispatch(getChefMenuAction.getChefMenuSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefMenuAction.getChefMenuSliceFailure(e?.response?.data));
  }
};
export default getChefMenuSlice.reducer;
export const getChefMenuAction = getChefMenuSlice.actions;
